// Vuex/backend names for entry layouts
export const FLIP_BOOK_LAYOUT = "FlipBookLayout";
export const IFRAME_LAYOUT = "PersonLayoutiframe";
export const IFRAME_SHEET_LAYOUT = "PersonLayoutiframeSheet";
export const ENTRY_LAYOUT_5 = "EntryLayout5";
export const ENTRY_LAYOUT_4 = "EntryLayout4";
export const ENTRY_LAYOUT_3 = "EntryLayout3";
export const ENTRY_LAYOUT_2 = "EntryLayout2";
export const ENTRY_LAYOUT_1 = "EntryLayout1";
export const PHOTO_AND_ATTRIBUTES_LAYOUT = "PhotoAndAttributesLayout";
export const PERSON_PAGE_FULL_LAYOUT_LANDSCAPE =
  "PersonPageFullLayoutLandscape";
export const PERSON_PAGE_FULL_LAYOUT_2 = "PersonPageFullLayout2";
export const PERSON_PAGE_FULL_LAYOUT = "PersonPageFullLayout";
export const JUST_PHOTO_LAYOUT = "JustPhotoLayout";
export const SLIDESHOW_AND_TITLE_LAYOUT = "SlideshowAndTitleLayout";
export const ALL_TEXT_NO_PHOTO_LAYOUT = "AllTextNoPhotoLayout";
export const HALF_DESCRIPTION_HALF_PHOTO_LAYOUT =
  "HalfDescriptionHalfPhotoLayout";
export const DESCRIPTION_AND_MEDIA_LAYOUT = "DescriptionAndMediaLayout";
export const PHOTO_LAYOUT = "PhotoLayout";

// components names that are different from Vuex/backend stored name
export const FULL_CONTENT_LAYOUT_LANDSCAPE = "FullContentLayoutLandscape";
export const FULL_CONTENT_LAYOUT_2 = "FullContentLayout2";
export const FULL_CONTENT_LAYOUT = "FullContentLayout";

// misc
export const CARD_PREVIEW = "cardPreview";
export const PERSON_LAYOUT_CATEGORY_NAME_CARD_PREVIEW =
  "PersonLayoutCategoryNameCardPreview";

export const DYNAMIC_MOBILE_LAYOUT = "DynamicMobileLayoutController";
export const DYNAMIC_ENTRY_LAYOUT = "DynamicEntryLayout";

export default function getEntryLayout(layoutName) {
  let comp;
  switch (layoutName) {
    case PHOTO_LAYOUT:
      comp = {
        name: PHOTO_LAYOUT,
      };
      break;
    case DESCRIPTION_AND_MEDIA_LAYOUT:
      comp = {
        name: DESCRIPTION_AND_MEDIA_LAYOUT,
      };
      break;
    case HALF_DESCRIPTION_HALF_PHOTO_LAYOUT:
      comp = {
        name: HALF_DESCRIPTION_HALF_PHOTO_LAYOUT,
      };
      break;
    case ALL_TEXT_NO_PHOTO_LAYOUT:
      comp = {
        name: ALL_TEXT_NO_PHOTO_LAYOUT,
      };
      break;
    case SLIDESHOW_AND_TITLE_LAYOUT:
      comp = {
        name: SLIDESHOW_AND_TITLE_LAYOUT,
      };
      break;
    case JUST_PHOTO_LAYOUT:
      comp = {
        name: JUST_PHOTO_LAYOUT,
      };
      break;
    case FULL_CONTENT_LAYOUT:
      comp = {
        name: PERSON_PAGE_FULL_LAYOUT,
      };
      break;
    case FULL_CONTENT_LAYOUT_2:
      comp = {
        name: PERSON_PAGE_FULL_LAYOUT_2,
      };
      break;
    case FULL_CONTENT_LAYOUT_LANDSCAPE:
      comp = {
        name: PERSON_PAGE_FULL_LAYOUT_LANDSCAPE,
      };
      break;
    case PHOTO_AND_ATTRIBUTES_LAYOUT:
      comp = {
        name: PHOTO_AND_ATTRIBUTES_LAYOUT,
      };
      break;
    case ENTRY_LAYOUT_1:
      comp = {
        name: ENTRY_LAYOUT_1,
      };
      break;
    case ENTRY_LAYOUT_2:
      comp = {
        name: ENTRY_LAYOUT_2,
      };
      break;
    case ENTRY_LAYOUT_3:
      comp = {
        name: ENTRY_LAYOUT_3,
      };
      break;
    case ENTRY_LAYOUT_4:
      comp = {
        name: ENTRY_LAYOUT_4,
      };
      break;
    case ENTRY_LAYOUT_5:
      comp = {
        name: ENTRY_LAYOUT_5,
      };
      break;
    case CARD_PREVIEW:
      comp = {
        name: PERSON_LAYOUT_CATEGORY_NAME_CARD_PREVIEW,
      };
      break;
    case IFRAME_LAYOUT:
      comp = {
        name: IFRAME_LAYOUT,
      };
      break;
    case IFRAME_SHEET_LAYOUT:
      comp = {
        name: IFRAME_SHEET_LAYOUT,
      };
      break;
    case FLIP_BOOK_LAYOUT:
      comp = {
        name: FLIP_BOOK_LAYOUT,
      };
      break;
    case DYNAMIC_MOBILE_LAYOUT:
      comp = {
        name: DYNAMIC_MOBILE_LAYOUT,
      };
      break;
    case DYNAMIC_ENTRY_LAYOUT:
      comp = {
        name: DYNAMIC_ENTRY_LAYOUT,
      };
      break;
    default:
      comp = {
        name: ENTRY_LAYOUT_1,
      };
      break;
  }
  return comp;
}
